import React from "react";
import MonoButton from "../../kits/DesignKit/MonoButton";
import PaperGradientBG from "../../kits/DesignKit/PaperGradientBG";

const ZenPostHeroSection = ({
  eyebrow = "Schreiben & Publizieren",
  title = "Ein Text,",
  titleAccent = "viele Formate",
  subtitle = "Erstelle aus einem Artikel optimierte Posts für verschiedene Plattformen.",
  miniText,
  primaryCtaText = "Demo ansehen",
  onPrimaryCta = null,
  secondaryCtaText = "Plattformen",
  onSecondaryCta = null,
  stats = [],
}) => {
  const hasPrimary = typeof onPrimaryCta === "function";
  const hasSecondary = typeof onSecondaryCta === "function";

  return (
    <PaperGradientBG
    variant="zenBlack"
    fullHeight={false} className="py-20 px-4 sm:py-32 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl text-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-brand bg-transparent px-4 py-1.5 text-xs sm:text-sm font-semibold text-[#EFEBDC]font-mono">
          <span className="h-2 w-2 rounded-full bg-brand " />
           <span className="text-[#EFEBDC]">{eyebrow}</span>
        </div>

        <h1 className="mt-6 text-4xl sm:text-5xl lg:text-7xl font-extrabold tracking-tight text-[#EFEBDC] font-mono">
          {title}
          <span className="mt-2 block bg-brand bg-clip-text text-transparent">
            {titleAccent}
          </span>
        </h1>

        <p className="mt-6 text-base sm:text-sm lg:text-sm text-[#EFEBDC] max-w-3xl mx-auto leading-relaxed font-mono">
          {subtitle}
        </p>

        {miniText && (
          <p className="mt-3 text-[12px] sm:text-sm text-[#EFEBDC]/90 max-w-4xl mx-auto font-mono">
            {miniText}
          </p>
        )}

   

        {stats.length > 0 && (
          <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-2xl border border-brand bg-transparent px-4 py-4 text-center shadow-lg shadow-slate-950/40"
              >
                <div className="text-2xl sm:text-3xl font-bold text-brand">
                  {stat.value}
                </div>
                <div className="mt-1 text-xs sm:text-sm text-[#EFEBDC]">
                  {stat.label}
                </div>
              </div>



            ))}



               
          </div>

          
        )}
      </div>
    </PaperGradientBG>
  );
};

export default ZenPostHeroSection;
